function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "surface1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M80.625,10.75c-8.86035,0 -16.125,7.26465 -16.125,16.125v29.22656l-53.75,32.25v20.32422l53.75,-10.75v23.01172l-10.75,8.0625v21.29004l26.875,-15.11719l26.875,15.11719v-21.29004l-10.75,-8.0625v-23.01172l53.75,10.75v-20.32422l-53.75,-32.25v-29.22656c0,-8.86035 -7.26465,-16.125 -16.125,-16.125zM80.625,21.5c3.02344,0 5.375,2.35156 5.375,5.375v35.27344l53.75,32.25v1.17578l-53.75,-10.75v41.02636l-5.375,-3.02344l-5.375,3.02344v-41.02636l-53.75,10.75v-1.17578l53.75,-32.25v-35.27344c0,-3.02344 2.35156,-5.375 5.375,-5.375z"
}));

var SvgDescriptionDirection = function SvgDescriptionDirection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 172 172",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDescriptionDirection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/description-direction.ac3f221d.svg";
export { ForwardRef as ReactComponent };